import { h } from 'preact';
const  menu = (props) => (
	<svg viewBox="0 0 72 72" class={props.class}>
		<path xmlns="http://www.w3.org/2000/svg" d="M70,10.8v9.1H2v-9.1H70z M2,33.5v9.1h68v-9.1H2z M2,56.1v9.1h68v-9.1H2z" />
	</svg>
);
export default menu;


// WEBPACK FOOTER //
// ../q-components/components/icons/headerIcons/menu/index.js